import React, { Component } from 'react';
import { clearAdminToken, isAdminLoggedIn } from '../../APICall/Api.jsx';

const NAV = [
  { to: '/admin/dashboard',    icon: 'fas fa-tachometer-alt', label: 'Dashboard' },
  { to: '/admin/news',         icon: 'fas fa-newspaper',      label: 'News' },
  { to: '/admin/projects',     icon: 'fas fa-project-diagram',label: 'Projects' },
  { to: '/admin/trainings',    icon: 'fas fa-chalkboard-teacher', label: 'Trainings' },
  { to: '/admin/events',       icon: 'fas fa-calendar-alt',   label: 'Events' },
  { to: '/admin/services',     icon: 'fas fa-cogs',           label: 'Services' },
  { to: '/admin/publications', icon: 'fas fa-file-pdf',       label: 'Publications' },
  { to: '/admin/staff',        icon: 'fas fa-users',          label: 'Team / Staff' },
  { to: '/admin/sponsors',     icon: 'fas fa-handshake',      label: 'Sponsors' },
];

class AdminLayout extends Component {
  handleLogout = () => {
    clearAdminToken();
    this.props.history.push('/admin');
  };

  render() {
    const { children, title, history, location } = this.props;

    if (!isAdminLoggedIn()) {
      history.push('/admin');
      return null;
    }

    const currentPath = location ? location.pathname : '';

    return (
      <div className="bgg-admin-root">
        {/* Sidebar */}
        <aside className="bgg-admin-sidebar">
          <div className="bgg-admin-logo">
            <h2>Build <span>Green</span></h2>
            <p>Content Management</p>
          </div>

          <nav className="bgg-admin-nav">
            <div className="bgg-admin-nav-section">Navigation</div>
            {NAV.map((item) => (
              <button
                key={item.to}
                className={`bgg-admin-nav-item${currentPath === item.to ? ' active' : ''}`}
                onClick={() => history.push(item.to)}
              >
                <i className={item.icon} />
                {item.label}
              </button>
            ))}

            <div className="bgg-admin-nav-section" style={{ marginTop: 24 }}>Account</div>
            <a
              href="/"
              className="bgg-admin-nav-item"
              style={{ display: 'flex', alignItems: 'center', gap: 11 }}
            >
              <i className="fas fa-external-link-alt" />
              View Site
            </a>
            <button className="bgg-admin-nav-item" onClick={this.handleLogout}>
              <i className="fas fa-sign-out-alt" />
              Logout
            </button>
          </nav>
        </aside>

        {/* Main content */}
        <div className="bgg-admin-content">
          <div className="bgg-admin-topbar">
            <h3>{title || 'Admin Panel'}</h3>
            <button
              className="bgg-btn bgg-btn-danger bgg-btn-sm"
              onClick={this.handleLogout}
            >
              <i className="fas fa-sign-out-alt" /> Logout
            </button>
          </div>
          <div className="bgg-admin-page">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default AdminLayout;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminLayout.jsx